import { Link } from 'react-router-dom';
import { siteConfig } from '../config/siteConfig';

export default function PrivacyPage() {
  return (
    <section className="page-section legal-page">
      <div className="shell legal-shell">
        <header className="legal-hero">
          <span className="eyebrow">Son güncelleme: 19 Temmuz 2026</span>
          <h1>Gizlilik Politikası</h1>
          <p>
            Bu politika, Tripzy mobil uygulaması, web sitesi ve destek
            kanallarında hangi bilgilerin neden işlendiğini açıklar.
          </p>
          <div className="legal-notice">
            Bu metin ürünün mevcut teknik işleyişine göre hazırlanmıştır ve
            canlı yayın öncesinde ayrıca hukuki kontrolden geçirilmelidir.
          </div>
        </header>

        <div className="legal-layout">
          <nav className="legal-toc" aria-label="Sayfa içeriği">
            <strong>Bu sayfada</strong>
            <a href="#operator">İşletmeci ve iletişim</a>
            <a href="#data">İşlenen veriler</a>
            <a href="#purposes">İşleme amaçları</a>
            <a href="#providers">Hizmet sağlayıcılar</a>
            <a href="#retention">Saklama ve silme</a>
            <a href="#rights">Haklarınız</a>
          </nav>

          <article className="legal-content">
            <section id="operator">
              <h2>1. İşletmeci ve iletişim noktası</h2>
              <p>
                Hizmetin kamuya açık işletmeci adı <strong>Tripzy</strong>’dir.
                Gizlilik, destek ve hesap silme talepleri için{' '}
                {siteConfig.supportEmail ? (
                  <a href={'mailto:' + siteConfig.supportEmail}>
                    {siteConfig.supportEmail}
                  </a>
                ) : (
                  <Link to="/contact">iletişim formu</Link>
                )}{' '}
                kullanılabilir.
              </p>
            </section>

            <section id="data">
              <h2>2. İşlenen veri kategorileri</h2>
              <h3>Hesap ve profil bilgileri</h3>
              <ul>
                <li>Ad, e-posta adresi ve parolanın geri döndürülemez özeti.</li>
                <li>Şehir, ilçe, yaş aralığı ve ulaşım gibi kullanıcı tercihleri.</li>
                <li>Giriş zamanı, e-posta doğrulama ve güvenilir cihaz bilgileri.</li>
                <li>
                  Android cihaz kimliği; oturum güvenliği, bildirim ve kötüye
                  kullanım önleme gibi işlevlerde kullanılır.
                </li>
              </ul>

              <h3>Konum, keşif ve gezi verileri</h3>
              <ul>
                <li>
                  İzin verdiğinizde güncel veya seçtiğiniz konum; yakındaki
                  yerleri, mesafeleri ve rotaları göstermek için kullanılır.
                </li>
                <li>Kaydettiğiniz mekânlar, listeler ve rotalar.</li>
                <li>
                  Oluşturduğunuz gezi planları, günlük duraklar, gezi ilerlemesi
                  ve tamamlanan yerler.
                </li>
                <li>
                  İlgi alanları, kaydetme ve benzeri kullanım davranışlarından
                  elde edilen kişiselleştirme sinyalleri.
                </li>
                <li>
                  Keşif Paneli’ne yazdığınız serbest metin, özellik etkinse
                  isteğinizi yapılandırılmış bir mekân niyetine dönüştürmek için
                  OpenAI’ye gönderilebilir. Tripzy bu ham sorguyu veritabanında,
                  uygulama loglarında veya öneri önbelleğinde saklamaz.
                </li>
              </ul>

              <h3>İçerik, ödeme ve teknik veriler</h3>
              <ul>
                <li>Yorumlar, puanlar, şikâyetler ve gezi geri bildirimleri.</li>
                <li>Firebase Cloud Messaging bildirim tokenı.</li>
                <li>
                  Google Play satın alma tokenı, ürün kimliği, abonelik planı ve
                  aboneliğin etkinlik durumu. Tam kart bilgileri Tripzy’ye ulaşmaz.
                </li>
                <li>
                  Hata kodu, ekran adı, uygulama sürümü, platform, sınırlı cihaz
                  bilgisi ve API hata ayrıntıları.
                </li>
                <li>
                  Kamera izni verdiğinizde bilet veya barkod tarama görüntüsü.
                  Barkod analizi cihaz üzerinde yapılır; görüntünün kendisi
                  sunucuya yüklenmez.
                </li>
              </ul>

              <h3>Web sitesi ve destek verileri</h3>
              <ul>
                <li>
                  İletişim formundaki ad, e-posta, konu, mesaj ve başvuru numarası.
                </li>
                <li>
                  Hesap silme talebi, doğrulama durumu, talep türü ve açıklama.
                </li>
                <li>
                  Kötüye kullanımı önlemek için ham adres yerine gizli anahtarla
                  tek yönlü özetlenen IP bilgisi ve sınırlandırılmış tarayıcı
                  bilgisi.
                </li>
                <li>
                  Cloudflare Web Analytics etkinse çerezsiz temel trafik ve
                  performans ölçümleri.
                </li>
              </ul>
            </section>

            <section id="purposes">
              <h2>3. Bilgileri neden kullanıyoruz?</h2>
              <ul>
                <li>Hesap açmak, oturum güvenliğini sağlamak ve kimliği doğrulamak.</li>
                <li>Yakındaki yerleri, rota ve navigasyon seçeneklerini sunmak.</li>
                <li>Gezi planlarını oluşturmak, kaydetmek ve ilerlemeyi göstermek.</li>
                <li>Tercihlere göre önerileri ve uygulama deneyimini geliştirmek.</li>
                <li>Premium haklarını Google Play üzerinden doğrulamak.</li>
                <li>Bildirim göndermek, teknik hataları tespit etmek ve çözmek.</li>
                <li>Destek, gizlilik ve hesap silme taleplerini sonuçlandırmak.</li>
                <li>Spam, otomasyon ve hizmetin kötüye kullanımını önlemek.</li>
              </ul>
            </section>

            <section id="providers">
              <h2>4. Üçüncü taraf hizmetler</h2>
              <p>
                Bir özelliği sağlamak için gereken sınırlı bilgi aşağıdaki hizmet
                sağlayıcılarına aktarılabilir. Her hizmet kendi gizlilik
                koşullarına tabidir.
              </p>
              <div className="provider-grid">
                <div><strong>Google Maps ve Places</strong><span>Harita, yer arama ve yer ayrıntıları</span></div>
                <div><strong>OpenAI</strong><span>Etkinse Keşif Paneli sorgusundan yalnızca yapılandırılmış öneri niyeti çıkarma</span></div>
                <div><strong>OpenRouteService ve OSRM</strong><span>Rota ve mesafe hesaplama</span></div>
                <div><strong>Transit sağlayıcısı</strong><span>Yalnızca yapılandırılmışsa toplu taşıma rotası</span></div>
                <div><strong>Firebase Cloud Messaging</strong><span>Anlık bildirim teslimi</span></div>
                <div><strong>Google Play Billing</strong><span>Satın alma ve abonelik doğrulama</span></div>
                <div><strong>SMTP / Gmail</strong><span>Doğrulama ve destek e-postaları</span></div>
                <div><strong>Wikipedia</strong><span>Yerler hakkındaki genel bilgi içeriği</span></div>
                <div><strong>Cloudflare Turnstile</strong><span>Formlarda bot ve kötüye kullanım önleme</span></div>
                <div><strong>Cloudflare Web Analytics</strong><span>Etkinse çerezsiz temel trafik ölçümü</span></div>
              </div>
            </section>

            <section id="retention">
              <h2>5. Saklama, güvenlik ve silme</h2>
              <p>
                Bilgiler, ilgili özelliği sunmak, güvenlik ve yasal yükümlülükleri
                yerine getirmek için gereken süre boyunca tutulur. Erişim
                kontrolleri, parolaların özetlenmesi, doğrulama kodlarının HMAC
                özeti ve aktarım sırasında HTTPS gibi önlemler kullanılır.
              </p>
              <ul>
                <li>Hesap silme doğrulama kodları 10 dakika sonra silinir.</li>
                <li>
                  Keşif Paneli’nin ham sorgusu Tripzy tarafından kalıcı olarak
                  saklanmaz; tekrar maliyetini azaltan önbellek yalnızca gizli
                  anahtarlı sorgu özetiyle yapılandırılmış sonucu tutar.
                </li>
                <li>Çözülen normal iletişim talepleri 12 ay sonra silinir.</li>
                <li>
                  Tamamlanan hesap silme taleplerindeki kişisel alanlar hemen
                  anonimleştirilir.
                </li>
                <li>
                  Anonim işlem izi 12 ay tutulur ve ardından otomatik olarak silinir.
                </li>
              </ul>
              <p>
                Hesap silme; kullanıcı kaydının yanında kaydedilen yerleri,
                rotaları, etkinlikleri, yorumları, tercihleri, gezi planlarını,
                geri bildirimleri, kişiselleştirme belleğini ve kullanıcıya bağlı
                hata kayıtlarını kapsar. Diğer içeriklerdeki beğeni ve şikâyet
                referansları da kaldırılır.
              </p>
            </section>

            <section id="rights">
              <h2>6. Tercihleriniz ve haklarınız</h2>
              <p>
                Uygulama izinlerini Android ayarlarından kapatabilir, bildirim
                tercihlerinizi değiştirebilir, verileriniz hakkında bilgi
                isteyebilir veya düzeltme ve silme talebinde bulunabilirsiniz.
                Hesap ve veri silmek için doğrulanmış{' '}
                <Link to="/delete-account">hesap silme formunu</Link> kullanın.
              </p>
              <p>
                Aktif Google Play aboneliği, hesabın silinmesiyle otomatik olarak
                iptal olmaz. Aboneliğin ayrıca Google Play üzerinden iptal edilmesi
                gerekir.
              </p>
            </section>

            <section>
              <h2>7. Değişiklikler</h2>
              <p>
                Ürün veya yasal gereklilikler değiştiğinde bu politika
                güncellenebilir. Önemli değişikliklerde güncelleme tarihi
                yenilenir ve uygun olduğunda uygulama içinden bildirim yapılır.
              </p>
            </section>
          </article>
        </div>
      </div>
    </section>
  );
}
